/* eslint-disable */
import React, { Component } from 'react';
import TreeView from 'react-treeview';
import print from '../images/print.png';

export default class Program extends Component {
  constructor(props) {
    super(props);

    this.Parent = this.Parent.bind(this);
    this.TreeChild = this.TreeChild.bind(this);
    this.Children = this.Children.bind(this);
    this.StructureTree = this.StructureTree.bind(this);
  }

  componentDidMount() {
    this.props.getPrograms();
    window.scrollTo(0, 0);
  }

  Parent(elem, i) {
    return (
      <TreeView
        defaultCollapsed={true}
        key={i}
        nodeLabel={
          <span className="Progr-parent">
            <span className="Progr-parent__name">
              {`${elem.compet_code} ${elem.study_result}`}
            </span>
            <span className="Progr-parent__grade">
              {elem.averageGrade !== 0 && elem.averageGrade}
            </span>
            <span className="Progr-parent__gradeText">
              {elem.competenceLevel}
            </span>

          </span>
        }
        itemClassName="" // <- в инспекторе можно найти как tree-view_item div.
        treeViewClassName="" // <- в инспекторе можно найти как tree-view div.
        childrenClassName="" // <- в инспекторе можно найти как tree-view_children item div.
      >
        <div >
          {elem.detail.map((structure, key) => this.TreeChild(structure, key))}
        </div>
      </TreeView>
    );
  }

  Children(elem) {
    return (
      <div className="Progr-child">
        <span className="Progr-child__name">
          {elem.title}
        </span>
        <span className="Progr-child__avg">
          {elem.avg_grade != 0 && elem.avg_grade}
        </span>
      </div>
    );
  }

  TreeChild(c, i) {
    return (
      <div key={i}>
        {c.detail && c.detail.length > 0 ? this.Parent(c, i) : this.Children(c, i) }
      </div>
    );
  }

  StructureTree() {
    const { programs } = this.props;
    return (
      <div>
        {programs && programs.map(this.TreeChild)}
      </div>
    );
  }

  render() {
    return (
      <div className="30.jpg upper">
        <div className="captions h1">Освоение основной образовательной программы</div>
        {/*<div className="Progr-TitleGrade">*/}
          {/*<p className="Progr-TitleGrade__average">Средний <br /> балл</p>*/}
          {/*<p className="Progr-TitleGrade__average">Уровень сформированности компетенции</p>*/}
        {/*</div>*/}
        {/*{this.StructureTree()}*/}
        {this.props.programs.map(elem => (
          <span className="Progr-parent">
            {`${elem.compet_code} ${elem.study_result}`}
          </span>
        ))}
      </div>
    );
  }
}

